import { render, staticRenderFns } from "./MaterialFinalStep.vue?vue&type=template&id=2c21290b&scoped=true"
import script from "./MaterialFinalStep.vue?vue&type=script&lang=js"
export * from "./MaterialFinalStep.vue?vue&type=script&lang=js"
import style0 from "./MaterialFinalStep.vue?vue&type=style&index=0&id=2c21290b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21290b",
  null
  
)

export default component.exports